export var defaultProps = {
    className: '',
    icon: '',
    shape: 'circle',
    size: 'normal',
    src: '',
    alt: '',
    onError: function (event) { },
};
